import { Controller } from "@hotwired/stimulus";

const VAT_COUNTRY_MAP = {
  AT: "AT",
  BE: "BE",
  BG: "BG",
  CY: "CY",
  CZ: "CZ",
  DE: "DE",
  DK: "DK",
  EE: "EE",
  EL: "GR",
  ES: "ES",
  FI: "FI",
  FR: "FR",
  HR: "HR",
  HU: "HU",
  IE: "IE",
  IT: "IT",
  LT: "LT",
  LU: "LU",
  LV: "LV",
  MT: "MT",
  NL: "NL",
  PL: "PL",
  PT: "PT",
  RO: "RO",
  SE: "SE",
  SI: "SI",
  SK: "SK",
};

export default class extends Controller {
  static targets = ["vatId", "countrySelect"];

  connect() {
    this.updateCountryFromVAT();
  }

  updateCountryFromVAT() {
    const vat = this.vatIdTarget.value.toUpperCase().replace(/\s+/g, "");
    const prefix = vat.slice(0, 2);

    if (VAT_COUNTRY_MAP[prefix]) {
      this.countrySelectTarget.value = VAT_COUNTRY_MAP[prefix];
      ["input", "change"].forEach((eventName) => {
        this.countrySelectTarget.dispatchEvent(
          new Event(eventName, { bubbles: true })
        );
      });

      const postalCodeController =
        this.application.getControllerForElementAndIdentifier(
          this.countrySelectTarget,
          "postalCode"
        );

      if (postalCodeController) {
        postalCodeController.updatePostalCodePattern();
      }
    }
  }
}
